// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".bundle.min.js?h=" + {"46":"7f715ff804d9db25","288":"37821f92a24d18bf","718":"f8637e9281de97bf"}[chunkId] + "";
};